module.exports = __webpack_public_path__ + "static/fonts/rajdhani-regular-webfont.836d8f6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rajdhani-regular-webfont.woff
// module id = 101
// module chunks = 0